<template>
    <section class="container d-flex flex-wrap gap-3 gap-md-6 justify-content-center justify-content-sm-between align-items-center pb-4 pb-md-8 text-center mb-16 mb-lg-0" id="footer"><span class="fs-eight fw-medium n5-color order-sm-1">Copyright ©2025
        <router-link :to="{name: 'index'}" class="fs-eight fw-medium n5-color">codenova</router-link>. All Rights Reserved.</span></section>
</template>

<script>
export default {
    name: "AppFooter"
}
</script>